import React from 'react';

/**
 * Utility wrapper for React.lazy that catches ChunkLoadError (caused by Webpack HMR or new deployments)
 * and automatically reloads the page to load updated bundle chunks.
 */
export const lazyWithRetry = (componentImport) =>
  React.lazy(async () => {
    const pageHasBeenRefreshed = JSON.parse(
      window.sessionStorage.getItem('page-has-been-refreshed') || 'false'
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem('page-has-been-refreshed', 'false');
      return component;
    } catch (error) {
      console.warn('ChunkLoadError detected, attempting page refresh...', error);
      if (!pageHasBeenRefreshed) {
        window.sessionStorage.setItem('page-has-been-refreshed', 'true');
        window.location.reload();
        // Return a pending promise so React doesn't render error UI before page reloads
        return new Promise(() => {});
      }
      throw error;
    }
  });

export default lazyWithRetry;
